module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentRow"
  }, [_c('div', {
    staticClass: "contentRow__main-row",
    class: {
      'contentRow__main-row--opened': _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "contentRow__main-row__images"
  }, [_vm._t("left-images")], 2), _vm._v(" "), _c('div', {
    staticClass: "contentRow__main-row__content",
    class: {
      'contentRow__main-row--deactivated': _vm.markAsDeactivated
    }
  }, [_vm._t("main"), _vm._v(" "), (_vm.isOpen) ? _vm._t("main-open") : (!_vm.isOpen) ? _vm._t("main-close") : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "contentRow__main-row__actions"
  }, [(!_vm.notOpenable && !_vm.isOpen) ? _c('div', {
    staticClass: "contentRow__main-row__action contentRow__main-row__action--open",
    on: {
      "click": function($event) {
        _vm.sendOpen()
      }
    }
  }) : (!_vm.notOpenable && _vm.isOpen) ? _c('div', {
    staticClass: "contentRow__main-row__action contentRow__main-row__action--close",
    on: {
      "click": function($event) {
        _vm.sendClose()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.select) ? _c('div', {
    staticClass: "contentRow__main-row__action contentRow__main-row__action--select",
    class: {
      'contentRow__main-row__action--disabled': _vm.selectDisabled
    },
    on: {
      "click": function($event) {
        _vm.sendSelect()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('div', {
    staticClass: "contentRow__main-row__action contentRow__main-row__action--edit",
    on: {
      "click": function($event) {
        _vm.sendEdit()
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "contentRow__secondary-row"
  }, [_vm._t("bottom-actions")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec4cac2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ContentRow.vue
// module id = 1886
// module chunks = 2